//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Badge } from 'vant';
import { cartCount, getSearchDefault } from "@/api/index.js"
import { getCookie } from "@/utils/auth.js"
export default {
  name: 'tabBar',
  components: {
    [Badge.name]: Badge
  },
  data(){
  	return {
      // tabList:[{
      //   tab:'',
      //   name:'首页'
      // },{
      //   tab:'',
      //   name:''
      // },{
      //   tab:'',
      //   name:'养护'
      // },{
      //   tab:'',
      //   name:'购物车'
      // },{
      //   tab:'',
      //   name:'我的'
      // }],
      tabList:[{
        tab:'',
        name:'首页'
      },{
        tab:'',
        name:'养护'
      },
      {
        tab:'',
        name:'买家秀'
      },
      {
        tab:'',
        name:'购物车'
      },{
        tab:'',
        name:'我的'
      }],
      cartNum: 0
  	}
  },
  props : {
  	tag : {
      type: Number,
      default: 0
    }
  },
  created(){
  	console.log(this.$route,'route');
    if(getCookie('hdu') && getCookie('hdt')){
      this.getCartCount();
      this.getSearchDefaultFun();
    }
  },

  methods : {
    //获取购物车数量
    getCartCount() {
      cartCount().then(res=>{
        this.cartNum = res.data
      })
    },
    //获取搜索词默认词和本周限购
    getSearchDefaultFun() {
      let that = this;
      getSearchDefault().then(res=>{
        if(res.status == 1){
          // if(that.tabList.length > 1){
          //   that.tabList[1].name = res.result.default2;
          // }
        }
      })
    },
    checkTab(index) {
      var currenturl = window.location.href;
      var reflower = ".reflower.com.cn";
      var tradeUrl = "https://trade.reflower.com.cn/cart/goods/count"
      if (currenturl.indexOf("-ce.") >= 0) {
          reflower = "-ce.reflower.com.cn";
          tradeUrl = "https://trade-ce.reflower.com.cn/cart/goods/count"
      } else if (currenturl.indexOf(".cce.") >= 0) {
          reflower = ".cce.reflower.com.cn";
      }
      if(index==0){
        if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.navigateTo({ url: '/pages/newIndex/index' })
        } else {
            window.location.href = 'https://m' + reflower;
        }
      }
      // else if(index==1){
      //   if (window.__wxjs_environment === 'miniprogram') {
      //       wx.miniProgram.navigateTo({ url: '/pages/discovery/index' })
      //       //            window.location.href = "https://misc.reflower.com.cn/view/allShopping/develop1.html";
      //   } else {
      //       //          window.location.href = 'http://m'+reflower+'/community/';
      //       window.location.href = 'https://m.reflower.com.cn/customer/#/richPage?id=592'
      //   }
      // }
      else if(index== 1){
        if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.navigateTo({ url: '/pages/curing/index' })
        } else {
            //          sa.track('maintain_btn');
            window.location.href = 'https://h5.youzan.com/v2/showcase/feature?alias=8an92o2k&dc_ps=65397&redirect_count=2';
        }
      }
      else if(index== 2){
        if (window.__wxjs_environment === 'miniprogram') {
            // wx.miniProgram.navigateTo({ url: '/pages/curing/index' })
        } else {
            //          sa.track('maintain_btn');
          this.$router.push('/buyerShowList')
        }
      }
      else if(index== 3){
         if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.navigateTo({ url: '/pages/discovery/index' })
        } else {
//         window.location.href = 'https://m'+reflower+'/shoppingCart';
					this.$router.push('/shoppingCart')
        }
      }else{
        if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.navigateTo({ url: '/pages/center/index' })
        } else {
            window.location.href = 'https://my' + reflower + '/user/center';
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/footer.vue